import { apiurl } from '../../../config/apiUrl';
import axios from '../../../utils/axios';

export const fetchVesselRoles = async () => {
  const response = await axios.get(apiurl?.getVesselRoles);
  return response?.data;
};
